module.exports = __webpack_public_path__ + "img/selected5-min.2ca4715a.png";